<template>
  <BaseAction :action="action">
    <span>
      {{ action.description.includes('subjects') ? 'Add high school subjects' : 'Complete an assessment' }}
    </span>
  </BaseAction>
</template>

<script>
import BaseAction from '@/components/candidate/action_items/BaseAction'

// Vue Component
export default {
  components: { BaseAction },
  props: { action: Object },
}
</script>
